import Seo from "../components/Seo";

export default function NonAffiliation() {
  return (
    <>
      <Seo
        title="Library Non-Affiliation"
        description="HS Library Hangout is not sponsored, managed, approved, or endorsed by Oak Lawn Public Library."
      />
      <h1>Library Non-Affiliation</h1>
      <section className="card">
        <p>
          <strong>
            HS Library Hangout is an independently organized parent group. It is not sponsored, managed,
            approved, or endorsed by Oak Lawn Public Library.
          </strong>{" "}
          Library staff do not manage events, registrations, supervision, or questions for this group.
        </p>
        <p>
          We hold our gatherings in public meeting room space at Oak Lawn Public Library, the same way any
          other community group might reserve a room. The library provides the physical space only.
        </p>
        <p>
          All planning, communication, RSVP management, supervision, and safety expectations are entirely
          the responsibility of HS Library Hangout&rsquo;s volunteer parent organizers &mdash; not library
          staff.
        </p>
        <p>
          If you have questions about room policies or the library&rsquo;s own programs, please contact
          Oak Lawn Public Library directly. For questions about HS Library Hangout events, RSVPs, or this
          website, please use our <a href="/contact">contact form</a>.
        </p>
      </section>
    </>
  );
}
